import { select } from 'd3';
import { DrawSvgOptions } from '../types';
import Margin from '../Base/margin';

export function drawSvg(elementId: string, options?: DrawSvgOptions) {
  const h = options?.height || 100;
  const w = options?.width || 100;

  const margin = options?.margin || new Margin();
  const transform = options?.transform || `translate(${margin.left}, ${margin.top})`;

  const element = select(elementId).append('svg').attr('width', w).attr('height', h).append('g').attr('transform', transform);

  return element;
}
